module.exports = __webpack_public_path__ + "img/image_4.7fd4c888.png";